import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("f435c06e39", "._2bfddfa3112e21d0__root{container-name:widget;container-type:inline-size;height:100%;width:100%}");
}
export default {"root":"_2bfddfa3112e21d0__root"};
